// extracted by mini-css-extract-plugin
module.exports = {"background":"RatingStars_background__XXt08"};